
export default {
  name: 'BottomSheet',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    returnFocus: {
      type: null,
      default: null,
    },
  },
  computed: {
    hasFooter() {
      return !!(this.$scopedSlots.footer || this.$slots.footer)
    },
  },
}
